<!-- Specific day of the Week -->
<div class="one-column-container">
  <mat-form-field appearance="outline">
    <mat-label>Interval</mat-label>
    <span matTextPrefix>Every &nbsp;</span>
    <span matTextSuffix>&nbsp;{{ getIntervalSuffix() }}</span>
    <input matInput type="number" [formControl]="interval" placeholder="Every X weeks" />
    <mat-error *ngIf="intervalHasError()">{{intervalErrorMessage()}}</mat-error>
  </mat-form-field>

  <mat-slide-toggle
    [formControl]="dependency"
    color="primary">
    Wait for previous execution to complete?
  </mat-slide-toggle>

  <mat-card-subtitle>Weekdays</mat-card-subtitle>
  <mat-chip-listbox [formControl]="weeklyOtionsSelectedWeekday">
    <mat-chip-option *ngFor="let day of weekdays" [value]="day">
      {{day | slice:0:3 | titlecase}}
    </mat-chip-option>
  </mat-chip-listbox> 

  <mat-form-field appearance="outline">
    <mat-label>Continuation Mode</mat-label>
    <mat-select [formControl]="continuationMode">
        <mat-option *ngFor="let continuationMode of continuationModes" [value]="continuationMode">{{ continuationMode | titlecase }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
